import React from 'react';
import { AnchoredView } from '@shared/components/AnchoredSheet';
import { View } from '@shared/components/View';
import { API } from '@shared/types/api';
import { ReactionButton } from './ReactionButton';
import { ReactionPicker } from './ReactionPicker';
import styles from './ReactionButtonWithPicker.module.css';

export interface ReactionButtonWithPickerProps {
  testID?: string;
  selected: API.ReactionType[];
  onToggleReaction: (reaction: API.ReactionType, add: boolean) => void;
  anchorName: string;
}

interface State {
  showingPicker: boolean;
}

/*
    Combine a reaction button with a reaction picker when pressed.
*/
export class ReactionButtonWithPicker extends React.PureComponent<
  ReactionButtonWithPickerProps,
  State
> {
  state: State = { showingPicker: false };

  showPicker = () => {
    this.setState({ showingPicker: true });
  };

  hidePicker = () => {
    this.setState({ showingPicker: false });
  };

  render() {
    const { testID, selected, onToggleReaction, anchorName } = this.props;
    const { showingPicker } = this.state;
    return (
      <>
        <View style={{ anchorName }}>
          <ReactionButton onClick={this.showPicker} testID={testID} />
        </View>
        {showingPicker && (
          <AnchoredView anchorName={anchorName} onClose={this.hidePicker} className={styles.picker}>
            <ReactionPicker
              selected={selected}
              onToggleReaction={(reactionType, add) => {
                this.hidePicker();
                onToggleReaction(reactionType, add);
              }}
              testID={testID ? `${testID}-picker` : undefined}
            />
          </AnchoredView>
        )}
      </>
    );
  }
}
